// src/components/cognito.js
import { CognitoUserPool, CognitoUser, AuthenticationDetails, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { COGNITO_CONFIG } from '../config/cognitoConfig';

// Initialize User Pool
const userPool = new CognitoUserPool({
  UserPoolId: COGNITO_CONFIG.UserPoolId,
  ClientId: COGNITO_CONFIG.ClientId,
});

// Sign In Function
export const signIn = (email, password) => {
  const user = new CognitoUser({
    Username: email,
    Pool: userPool,
  });

  const authDetails = new AuthenticationDetails({
    Username: email,
    Password: password,
  });

  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess: (result) => {
        // You can retrieve tokens here if needed
        const accessToken = result.getAccessToken().getJwtToken();
        const idToken = result.getIdToken().getJwtToken();
        const refreshToken = result.getRefreshToken().getToken();

        resolve({
          success: true,
          accessToken,
          idToken,
          refreshToken,
          user: {
            email,
            cognitoGuid: result.getIdToken().payload.sub, // Retrieve Cognito GUID
          },
        });
      },
      onFailure: (err) => {
        reject({
          success: false,
          message: err.message || 'Authentication failed',
        });
      },
    });
  });
};

// Sign Up Function (Optional: Update if you want to use Cognito for signup)
export const signUp = (email, password, firstName, lastName) => {
  const attributeList = [];

  const dataFirstName = {
    Name: 'given_name',
    Value: firstName,
  };

  const dataLastName = {
    Name: 'family_name',
    Value: lastName,
  };

  // Additional attributes can be added here

  attributeList.push(new CognitoUserAttribute(dataFirstName));
  attributeList.push(new CognitoUserAttribute(dataLastName));

  return new Promise((resolve, reject) => {
    userPool.signUp(email, password, attributeList, null, (err, result) => {
      if (err) {
        reject({
          success: false,
          message: err.message || 'Signup failed',
        });
        return;
      }
      resolve({
        success: true,
        user: result.user,
        userConfirmed: result.userConfirmed,
      });
    });
  });
};

// Confirm Sign Up Function
export const confirmSignUp = (email, confirmationCode) => {
    const user = new CognitoUser({
      Username: email,
      Pool: userPool,
    });
  
    return new Promise((resolve, reject) => {
      user.confirmRegistration(confirmationCode, true, (err, result) => {
        if (err) {
          reject({
            success: false,
            message: err.message || 'Confirmation failed',
          });
          return;
        }
        resolve({
          success: true,
          message: result, // Typically 'SUCCESS' upon successful confirmation
        });
      });
    });
  };
  
  // **New Function: Resend Confirmation Code**
  export const resendConfirmationCode = (email) => {
    const user = new CognitoUser({
      Username: email,
      Pool: userPool,
    });
  
    return new Promise((resolve, reject) => {
      user.resendConfirmationCode((err, result) => {
        if (err) {
          reject({
            success: false,
            message: err.message || 'Resend confirmation code failed',
          });
          return;
        }
        resolve({
          success: true,
          message: result, // Typically 'Code sent to your email.'
        });
      });
    });
  };
  export const forgotPassword = (email) => {
    const user = new CognitoUser({
      Username: email,
      Pool: userPool,
    });
  
    return new Promise((resolve, reject) => {
      user.forgotPassword({
        onSuccess: () => {
          resolve({
            success: true,
            message: 'Password reset code sent successfully',
          });
        },
        onFailure: (err) => {
          reject({
            success: false,
            message: err.message || 'Failed to initiate password reset',
          });
        },
      });
    });
  };
  
  export const confirmPasswordReset = (email, code, newPassword) => {
    const user = new CognitoUser({
      Username: email,
      Pool: userPool,
    });
  
    return new Promise((resolve, reject) => {
      user.confirmPassword(code, newPassword, {
        onSuccess: () => {
          resolve({
            success: true,
            message: 'Password reset successful',
          });
        },
        onFailure: (err) => {
          reject({
            success: false,
            message: err.message || 'Failed to reset password',
          });
        },
      });
    });
  };